import { ContentfulClientApi, createClient } from 'contentful';
import config from './config';

const SPACE_ID = config.CONTENTFUL_SPACE_ID;
const ACCESS_TOKEN = config.CONTENTFUL_ACCESS_TOKEN;
const PREVIEW_TOKEN = config.CONTENTFUL_PREVIEW_TOKEN;
const ENV = config.CONTENTFUL_ENVIRONMENT;

const CLIENT_DEFAULT = {
  space: SPACE_ID,
  accessToken: ACCESS_TOKEN,
  environment: ENV,
  removeUnresolved: true,
};

let client: ContentfulClientApi;

export function getClient() {
  if (!client) {
    client = createClient(CLIENT_DEFAULT);
  }
  return client;
}

let previewClient: ContentfulClientApi;

export const getPreviewClient = () => {
  if (!previewClient) {
    previewClient = createClient({
      ...CLIENT_DEFAULT,
      accessToken: PREVIEW_TOKEN,
      host: 'preview.contentful.com',
    });
  }
  return previewClient;
};
